import {
  Box,
  DistanceIcon,
  MarkerLocationIcon,
  NavList,
  Paragraph,
  WarningIcon,
} from '@deckee/deck-hand';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { hasFeatureEnabled } from '../../../../services/feature';
import {
  ROUTE_DISTANCE_TOOL,
  ROUTE_INCIDENT_REPORT,
  ROUTE_NEW_MARKER_SELECT_ENTITY_TYPE,
  ROUTE_REGULATIONS,
} from '../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../services/route/route-navigation';
import {
  moveMapToLocation,
  selectCurrentMapCenter,
  selectDropPinLocation,
  setDropPinLocation,
  showSelectMapPoint,
} from '../../../../services/store/modules/app-controls';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
import RegulationLocationCard from '../../Regulations/components/RegulationLocationCard';
import SafetyGearLocationCard from '../../Prepare/components/SafetyGearLocationCard';

const DropPinSheet: React.FC = () => {
  const dispatch = useDispatch();
  const currentMapCenter: { lat: number; lon: number } = useSelector(
    selectCurrentMapCenter,
  );
  const dropPinLocation: { latitude: number; longitude: number } = useSelector(
    selectDropPinLocation,
  );

  const theme = useTheme();

  const onMeasureDistanceClick = async () => {
    await captureEvent({
      type: 'drop-pin: measure distance',
      payload: {},
      sendToAmplitude: true,
    });
    transitionToNextRoute(ROUTE_DISTANCE_TOOL);
  };

  const onIncidentReportClick = async () => {
    await captureEvent({
      type: 'drop-pin: report incident',
      payload: {},
      sendToAmplitude: true,
    });
    transitionToNextRoute(ROUTE_INCIDENT_REPORT);
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted && dropPinLocation?.latitude && dropPinLocation?.longitude) {
      captureEvent({
        type: 'drop-pin',
        payload: {
          clickedLatitude: dropPinLocation.latitude,
          clickLongitude: dropPinLocation.longitude,
        },
        sendToAmplitude: true,
      });
      dispatch(
        moveMapToLocation({
          center: {
            lat: dropPinLocation.latitude,
            lon: dropPinLocation.longitude,
          },
        }),
      );
      // We do this here so the pin is centered on the map
      dispatch(showSelectMapPoint(-1));
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch, dropPinLocation]);
  return (
    <SheetLayout maxViewHeight="35" showMenuBar={false} heading="Dropped pin">
      <SheetBody pb="0" overflow="auto">
        <NavList>
          <NavList.Item
            onClick={() => {
              dispatch(
                setDropPinLocation({
                  latitude: currentMapCenter.lat,
                  longitude: currentMapCenter.lon,
                }),
              );
              transitionToNextRoute(ROUTE_NEW_MARKER_SELECT_ENTITY_TYPE, {
                lat: currentMapCenter.lat,
                lon: currentMapCenter.lon,
              });
            }}
            chevron
          >
            <MarkerLocationIcon color={theme.colors.primary} />
            <Box>
              <Paragraph>Add new marker</Paragraph>
            </Box>
          </NavList.Item>
          <SafetyGearLocationCard
            showLatLon={false}
            latitude={currentMapCenter?.lat}
            longitude={currentMapCenter?.lon}
          />
          <RegulationLocationCard
            onClick={() => {
              dispatch(
                setDropPinLocation({
                  latitude: currentMapCenter.lat,
                  longitude: currentMapCenter.lon,
                }),
              );
              transitionToNextRoute(ROUTE_REGULATIONS, {
                latitude: currentMapCenter?.lat,
                longitude: currentMapCenter?.lon,
              });
            }}
            showLatLon={false}
            latitude={currentMapCenter?.lat}
            longitude={currentMapCenter?.lon}
          />
          {hasFeatureEnabled('incident-reporting') && (
            <NavList.Item chevron onClick={onIncidentReportClick}>
              <WarningIcon color={theme.colors.primary} />
              <Paragraph>Report an incident</Paragraph>
            </NavList.Item>
          )}

          <NavList.Item chevron onClick={onMeasureDistanceClick}>
            <DistanceIcon color={theme.colors.primary} />
            <Paragraph>Measure distance</Paragraph>
          </NavList.Item>
        </NavList>
      </SheetBody>
    </SheetLayout>
  );
};
export default DropPinSheet;
